import { graphql } from "@/api/graphql/types/gql";

export const SearchTidLinkedAccountsQuery = graphql(`
  query SearchTidLinkedAccounts(
    $request: BillingMsSearchTidLinkedAccountsRequest!
  ) {
    BillingMsSearchTidLinkedAccounts(request: $request) {
      data {
        id
        linkedAccountId
        updatedTs
        LinkedAccountIdData {
          number
          IdData {
            id
            name
          }
        }
      }
      pagination {
        page
        size
        total
      }
    }
  }
`);
